/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, updateSubtotal, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;



  /*--------Free Shipping---------*/
  function freeShip(cart_param, adjust_flag) {

    var free_shipping_amount = 125;
var cart_amount = (cart_param / 100);

function hideProgressSection() {
  $('.progess-bar').fadeOut(1500);
}

function showProgressSection() {
  $('.progess-bar').fadeIn(1500);
}


if (adjust_flag) {

  if (cart_amount == 0) {
    showProgressSection();
    let amount_left = (free_shipping_amount - cart_amount).toFixed(2);
    $(".progress-info .price_content").html("$" + amount_left);
    let amount_percentage = (cart_amount / free_shipping_amount) * 100;
    amount_percentage = amount_percentage + "%";
    $(".progess-bar .progress").css("width", amount_percentage);
    $(".progess-bar .progress").css("transition", "transition: all 0.4s");

    setTimeout(function () {
      $(".js-drawer-close").click();
    }, 2000)

  } else {
    let amount_left = (free_shipping_amount - cart_amount).toFixed(2);

    if (amount_left < 0) {
      $(".progress-info").html("CONGRATS! YOU HAVE UNLOCKED FREE SHIPPING!");
      setTimeout(function () { $(".progress-info,.cart-free-ship").addClass("more-space"); }, 1500);
      $(".progess-bar .progress").css("width", "100%");
      hideProgressSection();
    } else {
      showProgressSection();
      $(".progress-info").html('ALMOST THERE! ADD <span class="price_content"></span> TO UNLOCK FREE SHIPPING!');
      $(".progress-info,.cart-free-ship").removeClass("more-space");
      $(".progress-info .price_content").html("$" + amount_left);
      let amount_percentage = (cart_amount / free_shipping_amount) * 100;

      amount_percentage = amount_percentage + "%";
      $(".progess-bar .progress").css("width", amount_percentage);
      $(".progess-bar .progress").css("transition", "transition: all 0.4s");
    }
  }

} else {
  if (cart_amount >= free_shipping_amount) {
    $(".progress-info").html("CONGRATS! YOU HAVE UNLOCKED FREE SHIPPING!");
    setTimeout(function () { $(".progress-info,.cart-free-ship").addClass("more-space"); }, 1500);
    $(".progess-bar .progress").css("width", "100%");
    hideProgressSection();
  } else {
    // free shipping locked
    let amount_left = (free_shipping_amount - cart_amount).toFixed(2);
    $(".progress-info .price_content").html("$" + amount_left);
    $(".progress-info,.cart-free-ship").removeClass("more-space");
    let amount_percentage = (cart_amount / free_shipping_amount) * 100;
    amount_percentage = amount_percentage + "%";
    $(".progess-bar .progress").css("width", amount_percentage);
    $(".progess-bar .progress").css("transition", "transition: all 0.4s");
  }
}
}




/*============================================================================
  Initialise the plugin and define global options
==============================================================================*/
init = function (options) {

  // Default settings
  settings = {
    formSelector: 'form[action^="/cart/add"]',
    cartContainer: '#CartContainer',
    addToCartSelector: 'input[type="submit"]',
    cartCountSelector: null,
    cartCostSelector: null,
    moneyFormat: '$',
    disableAjaxCart: false,
    enableQtySelectors: true
  };

  // Override defaults with arguments
  $.extend(settings, options);

  // Select DOM elements
  $formContainer = $(settings.formSelector);
  $cartContainer = $(settings.cartContainer);
  $addToCart = $formContainer.find(settings.addToCartSelector);
  $cartCountSelector = $(settings.cartCountSelector);
  $cartCostSelector = $(settings.cartCostSelector);

  // General Selectors
  $body = $('body');

  // Track cart activity status
  isUpdating = false;

  // Setup ajax quantity selectors on the any template if enableQtySelectors is true
  if (settings.enableQtySelectors) {
    qtySelectors();
  }

  // Take over the add to cart form submit action if ajax enabled
  if (!settings.disableAjaxCart && $addToCart.length) {
    formOverride();
  }

  // Run this function in case we're using the quantity selector outside of the cart
  adjustCart();
};

loadCart = function () {
  $body.addClass('drawer--is-loading');
  ShopifyAPI.getCart(cartUpdateCallback);
};

updateCountPrice = function (cart) {
  if ($cartCountSelector) {
    $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

    if (cart.item_count === 0) {
      $cartCountSelector.addClass('hidden-count');
    }
  }
  if ($cartCostSelector) {
    $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
  }
};

formOverride = function () {
  $formContainer.on('submit', function (evt) {
    evt.preventDefault();

    // Add class to be styled if desired
    $addToCart.removeClass('is-added').addClass('is-adding');

    // Remove any previous quantity errors
    $('.qty-error').remove();

    $(evt.target).addClass('adding-to-cart');

    ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
  });
};

itemAddedCallback = function (product) {
  $addToCart.removeClass('is-adding').addClass('is-added');
  $formContainer.removeClass('adding-to-cart');

  ShopifyAPI.getCart(cartUpdateCallback);
};

updateSubtotal = function (data) {
  // Update subtotal DOM
  const subtotal = data.totalPrice;
  const compareTotalPrice = data.discountsApplied;
  const subtotalElm = document.querySelector('.carttotal-prices strong');
  const comparePriceElm = document.querySelector('.carttotal-prices s');
  const percentagesavedElm = document.querySelector('.carttotal-prices em');
  if (subtotalElm) {
    subtotalElm.innerHTML = subtotal;
  }
  if (comparePriceElm && compareTotalPrice && compareTotalPrice !== '$0.00') {
    comparePriceElm.innerHTML = compareTotalPrice;
  }
  else {
    comparePriceElm.innerHTML = '';
  }
  //show percentage saved
  // Parse the values
  const discountValue = parseFloat(String(subtotal).replace(/[^0-9.]/g, ''));
  const subtotalValue = parseFloat(String(compareTotalPrice).replace(/[^0-9.]/g, ''));

  // Avoid division by zero
  const percentageSaved = subtotalValue > 0 
    ? Math.floor((discountValue / subtotalValue) * 100)
    : 0;

  const roundedPercentageSaved = Math.round(percentageSaved); 
  const savingsText = `(${100-percentageSaved}% SAVINGS)`;
  if (roundedPercentageSaved>0) {
    percentagesavedElm.innerHTML = savingsText;
    percentagesavedElm.classList.add('percentagesavedElm_show');
  }else{
    percentagesavedElm.classList.remove('percentagesavedElm_show');
  }

};

itemErrorCallback = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  $addToCart.removeClass('is-adding is-added');

  var pageHasCollectionGrid = $('#product-loop').length || $('.collection-carousel').length;
  if (pageHasCollectionGrid) {
    $formContainer = $('form.adding-to-cart');
  }

  if (!!data.message) {
    if (data.status == 422) {
      $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
      $formContainer.removeClass('adding-to-cart');

      if (pageHasCollectionGrid) {
        setTimeout(function () {
          $formContainer.next().remove();
        }, 3000);
      }
    }
  }
};

cartUpdateCallback = function (cart) {
  // Update quantity and price
  updateCountPrice(cart);
  buildCart(cart);
};

buildCart = function (cart) {
  // Start with a fresh cart div
  $cartContainer.empty();

  // Show empty cart
  if (cart.item_count === 0) {

    // add class for empty message
    $("#CartDrawer").addClass("CartDrawer-isempty");

    /*const cart_grid = `
        <div id="global_cart_grid"><a class="cart_grid__cell" href="/collections/best-sellers">
              <div class="cart-squareimg">
			          <img src="//livesozy.com/cdn/shop/files/Cart_-_Best_Sellers.png?v=1787125291" alt="Best Sellers">
              </div>
              <span>Best Sellers</span>
            </a><a class="cart_grid__cell" href="/collections/new-arrivals">
              <div class="cart-squareimg">
			          <img src="//livesozy.com/cdn/shop/files/Cart_-_New_Arrivals.png?v=1787125291" alt="NEW ARRIVALS">
              </div>
              <span>NEW ARRIVALS</span>
            </a><a class="cart_grid__cell" href="/collections/one-piece">
              <div class="cart-squareimg">
			          <img src="//livesozy.com/cdn/shop/files/Cart_-_One_Piece.png?v=1787125291" alt="ONE PIECE">
              </div>
              <span>ONE PIECE</span>
            </a><a class="cart_grid__cell" href="/collections/bottoms">
              <div class="cart-squareimg">
			          <img src="//livesozy.com/cdn/shop/files/Cart_-_Bottoms.png?v=1787125291" alt="BOTTOMS">
              </div>
              <span>BOTTOMS</span>
            </a></div> 
      `;*/

    $("#CartDrawer").attr("data-thresholdcount", "0");
    $(".threshold-progresstextmain span").html("Plus <strong>Free Shipping</strong> when you spend $125+  <i>After all discounts & promotions <u>Terms*</u></i>");

    /*$cartContainer
      .append('<p class="empty-msg">' + "Your cart is currently empty" + '</p>');
  $cartContainer.append(cart_grid);*/

  var progressPercentage = 0;
  $(".threshold-progressbarlabelsreward").html("SHOP NOW!");
  $(".threshold-progressbarlabels").removeClass("threshold-progressone");
  $(".threshold-progressbarlabels").removeClass("threshold-progresstwo");
  $(".threshold-progressbarlabels").removeClass("threshold-progressfull");
  $(".threshold-progressbarlabels").addClass("threshold-progresszero");
  $(".threshold-progressbarlabeltitle").html("BUY 3 ITEMS <u>& GET <span><strong>20% OFF</strong></span> YOUR ORDER</u>");
  // Update or set a session variable
  sessionStorage.setItem("changeTextForTopBar", "true");
  sessionStorage.setItem("TextForTopBar", "BUY 3, GET 20% OFF | <u>SHOP NOW</u>");
  updateTopBarText();
  
  const progressBar = document.getElementsByClassName('threshold-progressbarfill')[0];
  if (progressBar) {
    progressBar.style.width = progressPercentage + '%';
  }

  const progressBar_singleoffer = document.getElementsByClassName('threshold-progressbarfill-singleoffer')[0];
  if (progressBar_singleoffer) {
    progressBar_singleoffer.style.width = progressPercentage + '%';
  }

  const progressbarlabelsreward_singleoffer = document.querySelector('.threshold-progressbarlabelsreward-singleoffer');
  progressbarlabelsreward_singleoffer.textContent = "SHOP NOW!";
  progressbarlabelsreward_singleoffer.style.left = '8.5%';
  progressbarlabelsreward_singleoffer.style.opacity = '1';
  
  cartCallback(cart);

  // Reset subtotal prices when cart is empty
  updateSubtotal({ totalPrice: Shopify.formatMoney(0, settings.moneyFormat).replace(/\.00$/, ''), discountsApplied: false });

  return;
}
else {
  // remove class for empty message
  $("#CartDrawer").removeClass("CartDrawer-isempty");
}

// Handlebars.js cart layout
var items = [],
  item = {},
  data = {},
  source = $("#CartTemplate").html(),
  template = Handlebars.compile(source);

var ThresholdCountItems = 0;
var compareTotalPrice = 0;

// Add each item to our handlebars.js data
$.each(cart.items, function (index, cartItem) {

  /* Hack to get product image thumbnail
   *   - If image is not null
   *     - Remove file extension, add _small, and re-add extension
   *     - Create server relative link
   *   - A hard-coded url of no-image
  */
  if (cartItem.image != null) {
    var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
  } else {
    var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
  }

  // show compare price?
  var showComparePrice = false;
  if (cartItem.original_line_price !== cartItem.line_price) {
    showComparePrice = true;
  }

  var discountMessage = false;
  if (cartItem.discounts.length > 0) {
    discountMessage = cartItem.discounts[0].title;
  }

  if (discountMessage && discountMessage.includes("HOLIDAY SALE 25% OFF")) {
    discountMessage = "(25% OFF)";
  }

  if (discountMessage && discountMessage.includes("BLACK FRIDAY SALE 30% OFF")) {
    discountMessage = "(30% OFF)";
  }

  if (discountMessage && discountMessage.includes("Buy 3 Get 20% Off")) {
    discountMessage = "(20% OFF)";
  }

  var comparePrice;
  var varID = cartItem.variant_id;

  var item_discountedPrice = Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat);
  var item_line_level_total_discount = Shopify.formatMoney(cartItem.line_level_total_discount, settings.moneyFormat);


  //if(showComparePrice == false){

      $.ajax({ 
        url: '/products/' + cartItem.handle + '.js', 
        dataType: 'json',
        async: false, 
        success: function(product){ 
          product["compare_at_price"] = 0;
          product.variants.forEach(function(variant) {
            //console.log(variant.compare_at_price);
            
            if ( variant.id == varID && variant.compare_at_price !== 0){
              comparePrice = variant.compare_at_price;
              var has_sale = true;
              return false;  

              //console.log('found a discout');
            }
          });
        }
      });


      if( comparePrice == null || comparePrice < 1){
        // console.log('no sale on this item');
        comparePrice = '';
      } else {
        comparePrice = comparePrice;
      }

      if (discountMessage) {
        compareTotalPrice += 0;  
        var itemcompareTotalPrice = 0;
        if(comparePrice!=""){
          var item_line_level_total_discount = Shopify.formatMoney(itemcompareTotalPrice - parseInt(cartItem.line_price), settings.moneyFormat);
          showComparePrice = true;
        }
      }
      else {
        if(comparePrice!=""){
          compareTotalPrice += (parseInt(comparePrice)*cartItem.quantity) - (parseInt(cartItem.price)*cartItem.quantity);
          var itemcompareTotalPrice = parseInt(comparePrice)*cartItem.quantity;
        }else{
          compareTotalPrice += 0;  
          var itemcompareTotalPrice = 0;
        }      

        if(comparePrice!=""){
          var item_discountedPrice = parseInt(comparePrice)*cartItem.quantity;
          item_discountedPrice = Shopify.formatMoney(item_discountedPrice, settings.moneyFormat);
          var item_line_level_total_discount = Shopify.formatMoney(itemcompareTotalPrice - parseInt(cartItem.line_price), settings.moneyFormat);
          showComparePrice = true;
        }

      }
      


  //}


  let is_rebuy_product = "false";

  /* Threshold if apply
  ProductVendorSelector.new(
    :not_one,
    ["Brands We Love", "Mystery"]
  ),
  ProductTypeSelector.new(
    :not_one,
    ["Mystery Bag", "Gift Card"]
  )*/

  var CanThreshold = false;

  if (cartItem.product_type != "Mystery" && cartItem.product_type != "Mystery Bag" && cartItem.product_type != "Gift Card" && cartItem.vendor != "Brands We Love" && cartItem.vendor != "Mystery") {
    CanThreshold = true;
    ThresholdCountItems = ThresholdCountItems + cartItem.quantity;
  }



  // Create item's data object and add to 'items' array
  item = {
    id: cartItem.variant_id,
    line: index + 1, // Shopify uses a 1+ index in the API
    url: cartItem.url,
    img: prodImg,
    name: cartItem.product_title,
    variation: cartItem.variant_title,
    properties: cartItem.properties,
    isRebuyProduct: is_rebuy_product,
    itemAdd: cartItem.quantity + 1,
    itemMinus: cartItem.quantity - 1,
    itemQty: cartItem.quantity,
    price: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
    discountedPrice: item_discountedPrice,
    line_level_total_discount: item_line_level_total_discount,
    original_line_price: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
    showComparePrice: showComparePrice,
    vendor: cartItem.vendor,
    discount_msg: discountMessage,
    brands_we_love_product: cartItem.vendor == "Brands We Love" ? true : false,
    final_sale: cartItem.properties !== null && cartItem.properties['_final-sale'] !== undefined,
    preorder: cartItem.properties !== null && cartItem.properties['_preorder'] !== undefined,
    thresholditem: CanThreshold
  };

  items.push(item);


});

// Gather all cart data and add to DOM
data = {
  items: items,
  note: cart.note,
  discountsApplied: cart.total_discount > 0 || compareTotalPrice > 0 ? Shopify.formatMoney(cart.total_discount + cart.total_price + compareTotalPrice, settings.moneyFormat).replace(/\.00$/, '') : false,
  totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat).replace(/\.00$/, '')
}

$cartContainer.append(template(data));

cartCallback(cart);

updateSubtotal(data);

freeShip(cart.total_price, false);

// Convert cart total from cents to dollars
const cartTotalDollars = cart.total_price  / 100;
const targetAmount = 125;

// Calculate the percentage of the progress bar
//let progressPercentage = (cartTotalDollars / targetAmount) * 100;
//if (progressPercentage > 100) progressPercentage = 100;


// Update progress text
if (cartTotalDollars >= targetAmount) {
  $(".threshold-progresstextmain span").html('<strong style="color:#FFEDE5">CONGRATS!</strong> You’ve unlocked <strong>FREE SHIPPING</strong> on your order!  <i>After all discounts & promotions <u>Terms*</u></i>');
} else {
  $(".threshold-progresstextmain span").html(`You are just <strong>$${(targetAmount - cartTotalDollars).toFixed(2)}</strong>  away from <strong>FREE SHIPPING!</strong> <i>After all discounts & promotions <u>Terms*</u></i>`);
}

if (ThresholdCountItems == 0) {
  var progressPercentage = 0;
  $(".threshold-progressbarlabelsreward").html("SHOP NOW!");
  $(".threshold-progressbarlabels").removeClass("threshold-progressone");
  $(".threshold-progressbarlabels").removeClass("threshold-progresstwo");
  $(".threshold-progressbarlabels").removeClass("threshold-progressfull");
  $(".threshold-progressbarlabels").addClass("threshold-progresszero");
  $(".threshold-progressbarlabeltitle").html("BUY 3 ITEMS <u>& GET <span><strong>20% OFF</strong></span> YOUR ORDER</u>");
  // Update or set a session variable
  sessionStorage.setItem("changeTextForTopBar", "true");
  sessionStorage.setItem("TextForTopBar", "BUY 3, GET 20% OFF | <u>SHOP NOW</u>");
  updateTopBarText();
}
else if (ThresholdCountItems == 1) {
  var progressPercentage = 33;
  $(".threshold-progressbarlabelsreward").html("ALMOST THERE!");
  $(".threshold-progressbarlabels").addClass("threshold-progressone");
  $(".threshold-progressbarlabels").removeClass("threshold-progresstwo");
  $(".threshold-progressbarlabels").removeClass("threshold-progressfull");
  $(".threshold-progressbarlabels").removeClass("threshold-progresszero");
  $(".threshold-progressbarlabeltitle").html("BUY 2 MORE ITEMS <u>& GET <span><strong>20% OFF</strong></span> YOUR ORDER</u>");
  // Update or set a session variable
  sessionStorage.setItem("changeTextForTopBar", "true");
  sessionStorage.setItem("TextForTopBar", "BUY 2 MORE TO UNLOCK 20% OFF | <u>SHOP NOW</u>");
  updateTopBarText();
}
else if (ThresholdCountItems == 2) {
  var progressPercentage = 63;
  $(".threshold-progressbarlabelsreward").html("JUST 1 MORE ITEM!");
  $(".threshold-progressbarlabels").removeClass("threshold-progressone");
  $(".threshold-progressbarlabels").addClass("threshold-progresstwo");
  $(".threshold-progressbarlabels").removeClass("threshold-progressfull");
  $(".threshold-progressbarlabels").removeClass("threshold-progresszero");
  $(".threshold-progressbarlabeltitle").html("BUY 1 MORE ITEM <u>& GET <span><strong>20% OFF</strong></span> YOUR ORDER</u>");
  // Update or set a session variable
  sessionStorage.setItem("changeTextForTopBar", "true");
  sessionStorage.setItem("TextForTopBar", "BUY 1 MORE TO UNLOCK 20% OFF | <u>SHOP NOW</u>");
  updateTopBarText();
}
else if (ThresholdCountItems > 2) {
  var progressPercentage = 100;
  $(".threshold-progressbarlabelsreward").html("");
  $(".threshold-progressbarlabels").removeClass("threshold-progressone");
  $(".threshold-progressbarlabels").removeClass("threshold-progresstwo");
  $(".threshold-progressbarlabels").addClass("threshold-progressfull");
  $(".threshold-progressbarlabels").removeClass("threshold-progresszero");
  $(".threshold-progressbarlabeltitle").html('<img class="imgpartyemoji" src="https://cdn.shopify.com/s/files/1/3012/3948/files/partyemoji.svg">CONGRATS!<img class="imgpartyemoji" src="https://cdn.shopify.com/s/files/1/3012/3948/files/partyemoji.svg"> <u>YOU’VE UNLOCKED <span><strong>20% OFF</strong></span> YOUR ORDER</u>');
  // Update or set a session variable
  sessionStorage.setItem("changeTextForTopBar", "true");
  sessionStorage.setItem("TextForTopBar", "CONGRATS! YOU’VE UNLOCKED 20% OFF");
  updateTopBarText();
}

// Get the progress bar and text elements by class name
const progressBar = document.getElementsByClassName('threshold-progressbarfill')[0];
if (progressBar) {
  progressBar.style.width = progressPercentage + '%';
}

// percentage of progress toward $125 (0–100%)
const progressPercent_singleoffer = Math.min((cartTotalDollars / targetAmount) * 100, 100);
const progressBar_singleoffer = document.getElementsByClassName('threshold-progressbarfill-singleoffer')[0];
if (progressBar_singleoffer) {
  progressBar_singleoffer.style.width = progressPercent_singleoffer + '%';
}

const progressbarlabelsreward_singleoffer = document.querySelector('.threshold-progressbarlabelsreward-singleoffer');

if (progressbarlabelsreward_singleoffer) {
  if (progressPercent_singleoffer === 100) {
    progressbarlabelsreward_singleoffer.textContent = "ALMOST THERE!";
    progressbarlabelsreward_singleoffer.style.left = '69%';
    progressbarlabelsreward_singleoffer.style.opacity = '0';
  } else if (progressPercent_singleoffer > 50) {
    progressbarlabelsreward_singleoffer.textContent = "ALMOST THERE!";
    progressbarlabelsreward_singleoffer.style.left = '69%';
    progressbarlabelsreward_singleoffer.style.opacity = '1';
  } else {
    progressbarlabelsreward_singleoffer.textContent = "SHOP NOW!";
    progressbarlabelsreward_singleoffer.style.left = '8.5%';
    progressbarlabelsreward_singleoffer.style.opacity = '1';
  }
}




/*
if (ThresholdCountItems == 0) {
  $("#CartDrawer").attr("data-thresholdcount", ThresholdCountItems);
  $(".threshold-progresstextmain span").html("Buy 4 items and get <strong>20% off</strong> your order!");
}
else if (ThresholdCountItems == 1) {
  $("#CartDrawer").attr("data-thresholdcount", ThresholdCountItems);
  $(".threshold-progresstextmain span").html("<strong>Add 1 more</strong> item for 10% off your order!");
}
else if (ThresholdCountItems == 2) {
  $("#CartDrawer").attr("data-thresholdcount", ThresholdCountItems);
  $(".threshold-progresstextmain span").html("<strong>Add 1 more</strong> item for 15% off your order!");
}
else if (ThresholdCountItems == 3) {
  $("#CartDrawer").attr("data-thresholdcount", ThresholdCountItems);
  $(".threshold-progresstextmain span").html("<strong>Add 1 more</strong> item for 20% off your order!");
}
else if (ThresholdCountItems >= 4) {
  $("#CartDrawer").attr("data-thresholdcount", "4");
  $(".threshold-progresstextmain span").html("<strong>Congrats!</strong>  You’ve unlocked 20% off your order!");
}
*/

/*try {
  if (cart.items.length > 0) init_buySaveMore_popup();
} catch (error) {
  console.info(`❌ 👉🏻Ajax Cart | cartCallback | ${error}`);
}*/
  };

cartCallback = function (cart) {
  $body.removeClass('drawer--is-loading');
  $body.trigger('ajaxCart.afterCartLoad', cart);

  if (window.Shopify && Shopify.StorefrontExpressButtons) {
    Shopify.StorefrontExpressButtons.initialize();
  }

  // append rebuy widget
  //console.log("REBUY", cart.item_count)
  //rebuy cart flyout widget init
  /*if ($("#RebuyCartWidget").hasClass("initialized")) {
    //refresh the content of inline-cart-upsell
    $.get('/pages/about-us?view=inline-cart', function (a) {
      $("#RebuyCartWidget").html(a);
    })
  }
  if (cart.item_count >= 1) {
    $("#RebuyCartWidget").addClass("initialized");
    if (window.innerWidth < 769) {
      $("#Mobile-RebuyCartWidget").html($("#RebuyCartWidget").html());
    } else {
      $($("#RebuyCartWidget")).insertBefore("#CartDrawer");
    }
  } else {
    $("#RebuyCartWidget").remove();
    $("#Mobile-RebuyCartWidget").html('');
  }

  var mediaQuery = window.matchMedia('(max-width: 769px)');

  // Check if screen size matches the media query
  if (mediaQuery.matches) {
    // Bind hover event to the button
    $('body .rebuy-product-block .rebuy-button').hover(function() {
      // Trigger touchend event
      $(this).trigger('click');
    });
  }*/

};

adjustCart = function () {
  // Delegate all events because elements reload with the cart

  // Add or remove from the quantity
  $body.on('click', '.ajaxcart__qty-adjust', function () {
    var $el = $(this),
      line = $el.data('line'),
      $qtySelector = $el.siblings('.ajaxcart__qty-num'),
      qty = parseInt($qtySelector.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // Add or subtract from the current quantity
    if ($el.hasClass('ajaxcart__qty--plus')) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }

    // If it has a data-line, update the cart.
    // Otherwise, just update the input's number
    if (line) {
      updateQuantity(line, qty);
    } else {
      $qtySelector.val(qty);
    }
  });



  //Remve item from cart
  $body.on('click', '.ajaxcart-remove-item', function () {
    var line = $(this).closest('.ajaxcart.row').attr("data-line");
    line = parseInt(line);
    updateQuantity(line, 0);
  });


  // Update quantity based on input on change
  $body.on('change', '.ajaxcart__qty-num', function () {
    var $el = $(this),
      line = $el.data('line'),
      qty = parseInt($el.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // If it has a data-line, update the cart
    if (line) {
      updateQuantity(line, qty);
    }
  });

  // Prevent cart from being submitted while quantities are changing
  $body.on('submit', 'form.ajaxcart', function (evt) {
    if (isUpdating) {
      evt.preventDefault();
    }
  });

  // Highlight the text when focused
  $body.on('focus', '.ajaxcart__qty-adjust', function () {
    var $el = $(this);
    setTimeout(function () {
      $el.select();
    }, 50);
  });

  function updateQuantity(line, qty) {
    isUpdating = true;

    // Add activity classes when changing cart quantities
    var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

    if (qty === 0) {
      $row.parent().addClass('is-removed');
    }

    // Slight delay to make sure removed animation is done
    setTimeout(function () {
      ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    }, 250);
  }

  // Save note anytime it's changed
  $body.on('change', 'textarea[name="note"]', function () {
    var newNote = $(this).val();

    // Update the cart note in case they don't click update/checkout
    ShopifyAPI.updateCartNote(newNote, function (cart) { });
  });
};

adjustCartCallback = function (cart) {
  isUpdating = false;

  // Update quantity and price
  updateCountPrice(cart);

  // Reprint cart on short timeout so you don't see the content being removed
  setTimeout(function () {
    ShopifyAPI.getCart(buildCart);
  }, 150);

  freeShip(cart.total_price, true);

};

createQtySelectors = function () {
  // If there is a normal quantity number field in the ajax cart, replace it with our version
  if ($('input[type="number"]', $cartContainer).length) {
    $('input[type="number"]', $cartContainer).each(function () {
      var $el = $(this),
        currentQty = $el.val();

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $("#AjaxQty").html(),
        template = Handlebars.compile(source),
        data = {
          id: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });
  }
};

qtySelectors = function () {
  // Change number inputs to JS ones, similar to ajax cart but without API integration.
  // Make sure to add the existing name and id to the new input element
  var numInputs = $('input[type="number"]');

  if (numInputs.length) {
    numInputs.each(function () {
      var $el = $(this),
        currentQty = $el.val(),
        inputName = $el.attr('name'),
        inputId = $el.attr('id');

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $("#JsQty").html(),
        template = Handlebars.compile(source),
        data = {
          id: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus,
          inputName: inputName,
          inputId: inputId
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });

    // Setup listeners to add/subtract from the input
    $('.js-qty__adjust').on('click', function () {
      var $el = $(this),
        id = $el.data('id'),
        $qtySelector = $el.siblings('.js-qty__num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 1) qty = 1;
      }

      // Update the input's number
      $qtySelector.val(qty);
    });
  }
};

validateQty = function (qty) {
  if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

module = {
  init: init,
  load: loadCart
};



return module;

}(ajaxCart || {}, jQuery));
